const lazy = path => () => import(`./${path}`);

export default [
  {
    path: "/transitionPage",
    name: "transitionPage",
    component: lazy("index"),
    meta: {
      title: ""
    }
  },
  {
    path: "/transitionPageNew",
    name: "transitionPageNew",
    component: lazy("indexNew"),
    meta: {
      title: ""
    }
  }
];
